import { observable } from "mobx";

import { FullClinicResponse, PermissionBit } from "../../../api";
import { AccessRules } from "../../../constants/roles";
import { DataModel } from "../../../models/data-model";

export type ClinicsItem = FullClinicResponse & { numPhysicians?: number };

export class Clinics extends DataModel<ClinicsItem> {
  readonly idAttr = "uuid";
  @observable accessor loading = false;

  constructor(
    data: ClinicsItem[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);

    // access
    this.access = {
      editRules: { medical: AccessRules.none, monitoring: AccessRules.visible },
      deleteRules: {
        medical: AccessRules.none,
        monitoring: AccessRules.visible,
      },
      historyRequiresMonitoring: false,
    };
  }

  init() {
    this.data = this.data.map((item) => {
      const numPhysicians = item.physicians?.length ?? 0;
      return { ...item, ["numPhysicians"]: numPhysicians };
    });
    super.init();
  }

  prepareDraft(item: ClinicsItem) {
    const field: Record<string, unknown> = super.prepareDraft(item);
    field["physicians"] = item.physicians?.map((p) => p.uuid) ?? [];
    return field;
  }
}
